export const routes = {
  main: '/',
};
